





import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ComponentsPartsNoitem extends Vue {
  @Prop({type: String, default: 'Здесь пусто'})
  text: string;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/noitem/Noitem.vue